import React from "react";
import { BsCameraVideo } from "react-icons/bs";
import { IoMdAddCircle } from "react-icons/io";
import { FaRegPenToSquare } from "react-icons/fa6";
import { PiTrendDown, PiTrendUp } from "react-icons/pi";
import { MdArrowBackIos } from "react-icons/md";
import { PiChatsTeardropBold } from "react-icons/pi";
import { FaRegUser } from "react-icons/fa";
import { FaRegCalendarCheck } from "react-icons/fa";
import { PiCalendarXBold } from "react-icons/pi";
import "./Notification.css"
import { notification } from "antd";

const Notification = ({ onBack, notifications }) => {
    const avatar = {
        female: "https://ucarecdn.com/c22b8f55-8c68-411e-a5c9-8b5b99c08701/femaleEmoji.svg",
        male: "https://ucarecdn.com/52c99efd-cba4-4fe1-93f2-e393088b7a0c/male.svg",
        other: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg",
      };
    return (
        <div className="notification-overlay">
            <div className="notification-top">
                <div className="noti-back" onClick={onBack}>
                    <MdArrowBackIos />
                </div>
                <p>My Notifications</p>
            </div>
            {notifications.length > 0 ?
                <div className="notification-div">
                    {notifications.map((notification, index) => (
                        <div key={index} className="noti-div">
                            {notification.category === "client" ? (
                                <img src={avatar[notification.gender]} alt="avatar" />
                            ) : (
                                <div className="noti-icondiv">
                                    {notification.category === "session" ? (
                                        <BsCameraVideo color={"white"} size={20} />
                                    ) : notification.category === "tasks" ? (
                                        <IoMdAddCircle color={"white"} size={20} />
                                    ) : notification.category === "case-notes" ? (
                                        <FaRegPenToSquare color={"white"} size={20} />
                                    ) : notification.category === "summary" ? (
                                        <PiTrendUp color={"white"} size={20} />
                                    ) : notification.category === "chat" ? (
                                        <PiChatsTeardropBold color={"white"} size={20} />
                                    ) : notification.category === "new" ? (
                                        <FaRegUser color={"white"} size={20} />
                                    ) : notification.category === "reschedule" ? (
                                        <FaRegCalendarCheck color={"white"} size={20} />
                                    ) : (
                                        <PiCalendarXBold color={"white"} size={20} />
                                    )}
                                </div>
                            )}
                            <div className="noti-right">
                                <p className="noti-date">{notification.date}</p>
                                <p className="noti-message">
                                    {notification.notification}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                : <p>No notification Found</p>}
        </div>
    );
};

export default Notification;